import { Link } from 'react-router-dom';

export function BrandCapitalCTA() {
  return (
    <section className="py-12 sm:py-16 lg:py-20 bg-slate-900">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight">
          Inizia a Valorizzare il Tuo Brand con Certezza
        </h2>
        
        <p className="text-base sm:text-lg lg:text-xl text-white/90 mb-8 sm:mb-12 max-w-3xl mx-auto">
          Richiedi una consulenza gratuita per scoprire come Brand Capital può supportare 
          la tua azienda con metodologie certificate e perizie difendibili
        </p>

        <div className="flex flex-col sm:flex-row justify-center items-center space-y-4 sm:space-y-0 sm:space-x-6">
          <Link
            to="/contatti"
            className="w-full sm:w-auto bg-white text-slate-900 px-8 sm:px-10 py-4 sm:py-5 rounded-full font-bold text-base sm:text-lg hover:bg-gray-100 transition-colors duration-300 whitespace-nowrap text-center"
          >
            Richiedi Consulenza Gratuita
          </Link>
          
          <Link
            to="/risorse"
            className="w-full sm:w-auto border-2 border-white text-white px-8 sm:px-10 py-4 sm:py-5 rounded-full font-bold text-base sm:text-lg hover:bg-white hover:text-slate-900 transition-colors duration-300 whitespace-nowrap text-center"
          >
            Scarica Brochure
          </Link>
        </div>
      </div>
    </section>
  );
}